import React, {Component} from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import {Amount, CreditCard, Expiry} from './creditCard';
import { CardNumber, CardButton } from './prepaidCard';
import {updateBalanceTopUpEwollet, onCloseHtmlForm, getPaymentStatus} from './../actions/creditCardActions';
import {connect} from 'react-redux';
import Alert from './Alert/Alert';
import {hideAlert} from './../actions/AlertActions';
import IndicatorLoading from './indicatorLoading/IndicatorLoading';
import T from 'i18n-react';

const errorMessageCardHolder = 'Please enter your card holder';
const errorMesssageNumber = <T.text tag='span' text="pincode_digit_validation"/>;
const errorMesssageCardNumber = <T.text tag='span' text="please_enter_card_num"/>;
const errorMessageCardNumberLength = "Please enter 16 digits of the  card number"
const errorMessageMonth = "Please enter your month";
const errorMessageLengthMonth = "Please enter 2 digits of the month";
const errorMessageYear = "Please enter your year";
const errorMessageLengthYear = "Please enter 4 digits of the year";
const errorMessageSecurityCode = "Please enter your security code";
const errorMesstageLengthSecurityCode = "Please enter 3 digits of the security code";

class CreditCardPage extends Component {
    constructor(props){
        super(props);
        this.state={
            cardHolder:'',
            errorCardHolder:'',
            amount:0.01,
            typeCreditCard:'MASTERCARD',
            cardNumber: '',
            errorCardNumber:'',
            month:'',
            errorMonth:'',
            year:'',
            errorYear:'',
            securityCode:'',
            errorSecurityCode:''
        }
    }

    closeHtmlForm = () => {
    this.setState({
        cardHolder:'',
        typeCreditCard:'MASTERCARD',
        cardNumber: '',
        amount:0.01,
        month:'',
        year:'',
        securityCode:''
    });
    this.props.onCloseHtmlForm();

    }

    componentDidMount() {
        console.log('componentDidMunt run');
    }

     shouldComponentUpdate(nextProps) {
         if ( this.props.htmlForm != nextProps.htmlForm) {
             if (nextProps.xid) {

            //  this.props.getPaymentStatus(nextProps.xid);
                let timer = setInterval(() => {
                    this.props.getPaymentStatus(nextProps.xid);
                    let status = this.props.paymentStatus;
                    if (status != "PENDING") {
                        clearInterval(timer);
                    }
                }, 5000);
            }
            if (nextProps.showHtmlForm == true) {
                setTimeout (() => {
                    this.closeHtmlForm();
                }, 2000);
            }
            return true;
        }
            return true;
     }

/*hideAlert = () => {
    this.props.hideAlert();
}*/

updateBalanceTopUpEwolletClick=() => {
    const { accountId, updateBalanceTopUpEwollet } = this.props;
    const {cardHolder,
           amount,
           typeCreditCard,
           cardNumber,
           month,
           year,
           securityCode} = this.state;
        this.props.hideAlert();
   if (!cardHolder){
        this.setState({errorCardHolder: errorMessageCardHolder});
    }  if (!cardNumber) {
        this.setState({errorCardNumber: errorMesssageCardNumber});
    }  if (!month){
        this.setState({errorMonth: errorMessageMonth});
    }  if (!year) {
        this.setState({errorYear: errorMessageYear});
    }  if (!securityCode){
        this.setState({errorSecurityCode: errorMessageSecurityCode});
    }  else {
    updateBalanceTopUpEwollet(accountId, amount, cardNumber, typeCreditCard, cardHolder, month, year, securityCode);
    }
}

cardHolderChanged = (e) => {
    let values = e.nativeEvent.target.value;
    if (!values) {
        this.setState({errorCardHolder: errorMessageCardHolder});
    } else {
        this.setState({errorCardHolder: ''});
    }
    this.setState({cardHolder: values});
}

amountChanged = (e) => {
    let values = e.nativeEvent.target.value;
    this.setState({amount:values});
}
cardNumberChanged= (e) => {
    let values = e.nativeEvent.target.value;
    this.setState({typeCreditCard:values});
}

creditCardNumberChanged = (e) => {
    let values = e.nativeEvent.target.value;
    if (!values) {
        this.setState({errorCardNumber: errorMesssageCardNumber});
       } else if (values && isNaN(values) == true){
         this.setState({errorCardNumber: errorMesssageNumber});
       } else if (values && values.length < 16) {
        this.setState({errorCardNumber: errorMessageCardNumberLength});
       } else {
        this.setState({errorCardNumber:''});
     }
    this.setState({cardNumber:values});
}

monthOnChanged = (e) => {
    let values = e.nativeEvent.target.value;
    if (!values){
        this.setState({errorMonth: errorMessageMonth });
    } else if (values && isNaN(values) == true ){
        this.setState({errorMonth: errorMesssageNumber});
    }else if (values && values.length > 2) {
        this.setState({errorMonth: errorMessageLengthMonth});
    } else if (values && values > 12){
        this.setState({errorMonth: errorMessageMonth });
    } else {
        this.setState({errorMonth:''});
    }
    this.setState({month:values});
}
yearOnChanged = (e) => {
    let values = e.nativeEvent.target.value;
    if (!values) {
        this.setState({errorYear: errorMessageYear})
    }else if (values && isNaN(values) == true){
        this.setState({errorYear: errorMesssageNumber});
    } else if (values && values.length != 4) {
        this.setState({errorYear: errorMessageLengthYear});
    } else {
        this.setState({errorYear: ''});
    }
    this.setState({year: values});
}

securityCodeChanged = (e) => {
    let values = e.nativeEvent.target.value;
    if (!values) {
        this.setState({errorSecurityCode: errorMessageSecurityCode});
    } else if (values && isNaN(values) == true ) {
        this.setState({errorSecurityCode: errorMesssageNumber});
    } else if (values && values.length !== 3) {
        this.setState({errorSecurityCode: errorMesstageLengthSecurityCode });
    } else {
        this.setState({errorSecurityCode: ''});
    }
    this.setState({securityCode:values});
}

    render() {
        const { history,
                typeMessage,
                textMessage,
                visible,
                htmlForm,
                showHtmlForm,
                buttonDisable,
                isLoadingPayment } = this.props;
        const message = {
            type: typeMessage,
            text: textMessage
        }
        return (
    <div className="col col-sm-10 col-md-8">
        <h4 className="title-screen">
          <T.text tag='span' text="with_credit_card"/>
        </h4>
        <div className="label-screen">
          <T.text tag='span' text="enter_card_data"/>
        </div>

        { showHtmlForm &&

            <iframe srcDoc={this.props.htmlForm} id="output_iframe" width="100%" height="100%" scrolling='auto' ></iframe>

        }

        { isLoadingPayment &&

                <IndicatorLoading />
        }

        { !isLoadingPayment && !showHtmlForm &&
            <form className ="creditCardForm">
                <CardNumber value={this.state.cardHolder}
                  error={this.state.errorCardHolder}
                  label={<T.text tag='span' text="cardholder"/>}
                  name = {"cardHolder"}
                  onChange={this.cardHolderChanged} />

                <Amount onChange={this.amountChanged} />

                <CreditCard onChange = {this.cardNumberChanged} checked={this.state.typeCreditCard} />

                <CardNumber value={this.state.cardNumber}
                  error={this.state.errorCardNumber}
                  label={<T.text tag='span' text="card_number"/>}
                  name = {"creditCardNumber"}
                  onChange={this.creditCardNumberChanged} />

                <Expiry value={this.state} error = {this.state} onChangedMonth={this.monthOnChanged}
                  onChangedYear={this.yearOnChanged} />

                <CardNumber value = {this.state.securityCode}
                  error={this.state.errorSecurityCode}
                  label={<T.text tag='span' text="card_cvv"/>}
                  name = {"securityCode"}
                  onChange={this.securityCodeChanged} />

                <ReactCSSTransitionGroup
                    transitionName="appear"
                    transitionEnterTimeout={500}
                    transitionLeaveTimeout={500}>
                 { visible == true  && <Alert  message={message} />}
                </ReactCSSTransitionGroup>

                <CardButton history={history}
                            onClick={this.updateBalanceTopUpEwolletClick}
                            classStyle = "btm-credir-card"  />
            </form>
        }
        </div>
    )}
}
export default connect((state) => {
    return {
    accountId: state.authReducer.accountId,
    visible: state.alert.visible,
    typeMessage: state.alert.type,
    textMessage: state.alert.message,
    htmlForm: state.creditCard.htmlForm,
    showHtmlForm: state.creditCard.showHtmlForm,
    xid: state.creditCard.xid,
    paymentStatus: state.creditCard.paymentStatus,
    paymentDescription: state.creditCard.paymentDescription,
    buttonDisable: state.creditCard.buttonDisable,
    isLoadingPayment: state.creditCard.isLoadingPayment
    }
},
{ updateBalanceTopUpEwollet, hideAlert, onCloseHtmlForm, getPaymentStatus })(CreditCardPage);



// WEBPACK FOOTER //
// ./src/components/CreditCardPage.js